export const price = [
    {
        image: './pictures/Pricing/icon1.svg',
        title: 'Design',
        essential: 'Essential includes:',
        srvcA: 'Website Design',
        srvcB: 'Mobile Design',
        srvcC: 'Web App Design',
        srvcD: 'Logo Design',
        srvcE: 'Personalized Design'
    },

    {
        image: './pictures/Pricing/icon2.svg',
        title: 'Lite Website',
        essential: 'Essential includes:',
        srvcA: 'Build static sites',
        srvcB: 'Host websites',
        srvcC: 'Landing page',
        srvcD: 'Personalized Design',
        srvcE: 'Portfolio Website',
    },

    {
        image: './pictures/Pricing/icon3.svg',
        title: 'Premium Website',
        essential: 'Essential includes:',
        srvcA: 'Maximum of 5 pages',
        srvcB: 'Host Website',
        srvcC: 'Slider',
        srvcD: 'Google Map Integration',
        srvcE: 'Product Detail Page'
    }
]